import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface GetIntegrationDashboardStatParams {
	dateFilter?: string
	startDate?: string
	endDate?: string
	client?: string
}
export interface GetIntegrationDashboardStatResponse {
	type:
		| {
				source: string
		  }
		| string
	records?: {
		date: string
		count: number
	}[]
	response?: {
		hour: number
		count: number
	}[]
}
export const getIntegrationDashboardStat = async (
	params: GetIntegrationDashboardStatParams
): Promise<GetIntegrationDashboardStatResponse> => {
	try {
		const { data } = await axios.get(
			'v1/conversation/management/integration-stats',
			{
				params,
			}
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getIntegrationDashboardStat
